// function to be added to OpenLayers.Map.prototype if needed
// 'this' in the function is the map object

const getInteractionByType = function (interactionType) {
  let interactions = this.getInteractions().getArray(),
      interaction;

  for (let i = 0, ii = interactions.length; i < ii; i++) {
    if (interactions[i] instanceof interactionType) {
        interaction = interactions[i];
        break;
    }
  }
  return interaction;
}

export default getInteractionByType;
